<script module lang="ts">
	// Context key set by DynamicEditingComponent for a container's child editors.
	export const EDITOR_NESTED = Symbol("editor-nested");
</script>

<script lang="ts">
	import { getContext, type Snippet } from "svelte";

	interface Props {
		children: Snippet;
	}

	let { children }: Props = $props();

	// A container editor renders its children through DynamicEditingComponent, which marks
	// them nested. Nested editors get their spacing from the container, so the inset is a no-op.
	const nested = getContext(EDITOR_NESTED) === true;
</script>

{#if nested}
	{@render children()}
{:else}
	<!-- Standard vertical inset for a top-level editor. This padding sits on scroll content
	     (not the scroll container), so it survives the scroll end, unlike padding on the
	     overflow element itself. -->
	<div class="py-6">
		{@render children()}
	</div>
{/if}
